import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';

@model.cacheDuration()
@model.urnResource('sync_status')
@doc.path('/sync_statuses/{?id}')
export default class SyncStatusModel extends ShopServiceModel {
	private declare _tsFilters: {
		'reference': Shop_SyncStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Shop_SyncStatusReference;

	public get color() {
		switch (this.reference) {
			case 'to_synchronize':
				return 'orange';
			case 'synchronized':
				return 'green';
		}
	}
}
